import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import Button from "../../../Button";
import Overlay from "../../../Overlay";
import HeaderOverlay from "../../../Project/Header";
import Title from "../../../Project/Title";
import { Radio } from "antd";
import { useDispatch } from "react-redux";
import { openModal, closeModal } from "../../../../data/slices/modals";
import "./index.scss";

function ExportTypeModal({ open, onCancel, data, ...rest }) {
  const dispatch = useDispatch();

  // Form validation schema
  const ExportSchema = Yup.object().shape({
    exportType: Yup.string().required("Veuillez sélectionner un type d'export"),
  });

  // Initial form values
  const initialValues = {
    exportType: "",
  };

  const exportOptions = [
    {
      value: "synthese_resultat",
      label: "Une synthèse du résultat",
    },
    {
      value: "tresorerie",
      label: "Une synthèse de trésorerie",
    },
    {
      value: "liste_ecritures",
      label: "Une liste des écritures",
    },
    {
      value: "bilan_fin_mois",
      label: "Un bilan",
    },
  ];

  // Map exportType to modal id
  const exportTypeToModalId = {
    synthese_resultat: "export-synthesis-result-modal",
    tresorerie: "export-synthesis-treso-modal",
    liste_ecritures: "export-writing-list-modal",
    bilan_fin_mois: "export-month-end-bilan-modal",
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    try {
      // Close this modal
      dispatch(closeModal("export-type-modal"));

      const modalId = exportTypeToModalId[values.exportType];
      if (modalId) {
        dispatch(
          openModal(modalId, {
            ...data,
            ...(modalId === "export-synthesis-result-modal" && {
              type: "categories_and_plan_comptable",
            }),
            ...(modalId === "export-writing-list-modal" && {
              tableType: "all",
            }),
            exportType: values.exportType,
          })
        );
      }
    } catch (error) {
      console.error("Export error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    } else {
      dispatch(closeModal("export-type-modal"));
    }
  };

  return (
    <Overlay show={open} closable={true}>
      <HeaderOverlay showlogo>
        <Title isDelete subTitle={`Choisir le type d'export`} />

        <Formik
          initialValues={initialValues}
          validationSchema={ExportSchema}
          onSubmit={handleFormSubmit}
          validateOnChange={true}
          validateOnBlur={true}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleSubmit,
          }) => {
            return (
              <Form className="export-type-form" onSubmit={handleSubmit}>
                <div className="export-type-content">
                  <div className="export-type-content-wrapper">
                    <div className="export-type-content-label">
                      Vous souhaitez exporter:
                    </div>
                    <div className="radio-options-wrapper">
                      <Radio.Group
                        name="exportType"
                        value={values.exportType}
                        onChange={(e) =>
                          setFieldValue("exportType", e.target.value)
                        }
                      >
                        {exportOptions.map((option) => (
                          <Radio
                            key={option.value}
                            value={option.value}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: 8,
                              fontSize: "1.7rem",
                              fontWeight: "500",
                            }}
                          >
                            <span style={{ marginLeft: 8 }}>
                              {option.label}
                            </span>
                          </Radio>
                        ))}
                      </Radio.Group>
                    </div>
                    {errors.exportType && touched.exportType && (
                      <div className="error-message">{errors.exportType}</div>
                    )}
                  </div>

                  <div className="verify-inputs-popup">
                    <Button
                      text={"Annuler"}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCancel();
                      }}
                      className={"action-button"}
                      htmlType="button"
                      disabled={isSubmitting}
                    />
                    <Button
                      text={"Continuer"}
                      htmlType="submit"
                      className={"action-button agree-action-button"}
                      iconClassName={"delete-icon"}
                      disabled={isSubmitting || !values.exportType}
                      loading={isSubmitting}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </HeaderOverlay>
    </Overlay>
  );
}

export default ExportTypeModal;
